<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Brand demo (see src/demo.css) -->
    <div class="app-brand demo" v-if="orientation !== 'horizontal'">
      <span class="app-brand-logo demo">
        <!-- <svg width="227" height="264" viewBox="0 0 227 264" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="227" height="264" fill="#E5E5E5"/>
        <rect width="227" height="264" rx="25" fill="#3BA0FE"/>
        <path d="M192.168 198.256C194.472 203.44 195.624 209.296 195.624 215.824C195.624 222.352 193.32 228.016 188.712 232.816C184.296 237.424 178.824 239.728 172.296 239.728C151.944 239.728 120.072 238.576 76.68 236.272C73.224 236.08 70.152 235.024 67.464 233.104C64.776 230.992 63.432 228.4 63.432 225.328C63.432 215.152 64.2 197.968 65.736 173.776C67.464 149.584 68.328 127.024 68.328 106.096C68.328 84.976 66.312 60.784 62.28 33.52C76.488 34.672 95.592 35.248 119.592 35.248C143.592 35.248 166.536 33.52 188.424 30.064C190.728 34.288 191.88 39.376 191.88 45.328C191.88 51.088 189.576 56.272 184.968 60.88C180.552 65.296 174.984 67.504 168.264 67.504C161.736 67.504 151.176 66.544 136.584 64.624C122.184 62.704 111.528 61.744 104.616 61.744C103.08 81.136 102.216 99.376 102.024 116.464C114.12 117.616 127.08 118.192 140.904 118.192C154.92 118.192 166.92 116.176 176.904 112.144C179.208 116.368 180.36 121.456 180.36 127.408C180.36 133.168 178.056 138.448 173.448 143.248C169.032 147.856 163.656 150.16 157.32 150.16C151.176 150.16 141.96 149.008 129.672 146.704C117.384 144.208 108.072 142.96 101.736 142.96C101.736 173.296 102.408 195.568 103.752 209.776C112.968 210.544 120.168 210.928 125.352 210.928C150.696 210.928 172.968 206.704 192.168 198.256Z" fill="#F9F9F9"/>
        </svg> -->
        <svg width="100%" height="100%" viewBox="0 0 103 116" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
          <path d="M101.759,83.138c-0.01,2.005 -1.084,3.853 -2.821,4.853l-47.853,27.555c-0.112,0.065 -0.24,0.099 -0.37,0.098c-0.125,0 -0.249,-0.033 -0.358,-0.096l-49.964,-28.325c-0.23,-0.13 -0.372,-0.375 -0.372,-0.639l-0.021,-47.65c0.002,-0.204 0.073,-0.381 0.207,-0.514c0.143,-0.142 0.344,-0.226 0.537,-0.225c0.129,0.001 0.246,0.035 0.369,0.109l7.458,4.469c1.708,1.022 2.748,2.869 2.738,4.859l-0.146,29.66c-0.01,2.037 1.08,3.92 2.852,4.926l17.742,10.067c1.719,0.975 3.72,0.884 5.633,-0.258c1.208,-0.722 1.962,-2.057 1.969,-3.484l0.132,-26.867c0.003,-0.553 0.512,-0.737 0.744,-0.735c0.122,0 0.233,0.031 0.351,0.097l7.369,4.143c1.783,1.002 2.883,2.892 2.872,4.936l-0.112,22.956c-0.007,1.402 0.541,2.709 1.542,3.678c0.943,0.911 2.229,1.436 3.531,1.443c0.896,0.004 1.785,-0.234 2.573,-0.69l27.788,-16.107c1.728,-1.001 2.797,-2.845 2.807,-4.843l0.166,-33.86c0.005,-0.886 -0.269,-1.745 -0.772,-2.42c-1.76,-2.361 -4.735,-2.984 -7.073,-1.483l-27.339,17.556c-0.119,0.076 -0.258,0.117 -0.401,0.116c-0.125,0 -0.248,-0.033 -0.358,-0.095l-48.583,-27.189c-0.279,-0.157 -0.478,-0.398 -0.504,-0.615l-0.007,-0.109c0.002,-0.264 0.129,-0.486 0.358,-0.624l46.209,-27.726c0.116,-0.069 0.248,-0.106 0.381,-0.105c0.133,0.001 0.263,0.037 0.377,0.106l24.62,14.842c0.213,0.128 0.374,0.3 0.416,0.447c0.023,0.081 0.035,0.164 0.034,0.244c-0.001,0.252 -0.124,0.476 -0.337,0.613l-8.026,5.178c-0.12,0.078 -0.258,0.119 -0.402,0.118c-0.127,-0.001 -0.253,-0.035 -0.364,-0.099l-13.218,-7.639c-0.766,-0.443 -1.639,-0.68 -2.523,-0.684c-0.959,-0.005 -1.897,0.261 -2.713,0.767l-15.049,9.357c-0.661,0.411 -1.184,0.982 -1.508,1.65l-0.028,0.06c-1.225,2.596 -0.078,5.702 2.439,7.079l15.288,8.362c0.741,0.405 1.577,0.62 2.419,0.624c0.958,0.006 1.895,-0.26 2.71,-0.764l31.622,-19.616c0.117,-0.072 0.253,-0.111 0.392,-0.11c0.119,0 0.237,0.031 0.343,0.087l11.5,6.115c1.847,0.982 2.998,2.908 2.987,5l-0.253,51.401Z" style="fill:#25a9e1;fill-rule:nonzero;"/>
        </svg>
      </span>
      <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal ml-2">EduSystem</router-link>
      <a href="javascript:void(0)" class="layout-sidenav-toggle sidenav-link text-large ml-auto" @click="toggleSidenav()">
        <i class="ion ion-md-menu align-middle"></i>
      </a>
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

    <!-- Links -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }" v-if="$can('account', 'active')">

      <sidenav-router-link icon="ion ion-ios-speedometer" to="/" :exact="true">Dashboard</sidenav-router-link>

      <sidenav-menu icon="ion ion-md-speedometer" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')" v-if="$can('manage', 'school')">
        <template slot="link-text">Command Center</template>
        <sidenav-router-link icon="ion ion-md-desktop" to="/accounts/info" :exact="true">Account Info</sidenav-router-link>
        <sidenav-router-link icon="ion ion-md-desktop" to="/educators" :exact="true">Educators</sidenav-router-link>
        <sidenav-router-link icon="ion ion-md-desktop" to="/emailreports" :exact="true">Email Class Reports</sidenav-router-link>
        <sidenav-router-link icon="ion ion-md-desktop" to="/emailreports/grade" :exact="true">Email Grade Reports</sidenav-router-link>
        <sidenav-router-link icon="ion ion-md-desktop" to="/emailreportshistory" :exact="true">Email History</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-book" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')"  v-if="$can('manage', 'curriculum')">
        <template slot="link-text">Curriculum</template>
        <sidenav-router-link to="/sections" :exact="true">Grades</sidenav-router-link>
        <sidenav-router-link to="/courses" :exact="true">Courses</sidenav-router-link>
        <sidenav-router-link to="/classes" :exact="true">Educator Classes</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-person-add" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')"  v-if="$can('manage', 'applications')">
        <template slot="link-text">Applications</template>
        <sidenav-router-link to="/applications" :exact="true">View Applications</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-people" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')">
        <template slot="link-text">Learners</template>
        <sidenav-router-link to="/learners" :exact="true">Learners</sidenav-router-link>
        <sidenav-router-link to="/subjects/learners" :exact="true" v-if="$can('manage', 'learners')">Learner Subjects</sidenav-router-link>
        <sidenav-router-link to="/guardians" :exact="true" v-if="$can('manage', 'learners')">Parents</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-document" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')">
        <template slot="link-text">Assessments</template>
        <sidenav-router-link icon="ion ion-md-desktop" to="/subjects" :exact="true">Setup</sidenav-router-link>
        <sidenav-router-link to="/marks/assessments/capture" :exact="true">Capture Marks</sidenav-router-link>
        <sidenav-router-link to="/marks/results/capture" :exact="true">Capture Results</sidenav-router-link>
        <sidenav-router-link to="/marks/results" :exact="true">Learner Results</sidenav-router-link>
        <!-- <sidenav-router-link to="/marks/outstanding" :exact="true">Outstanding Marks</sidenav-router-link> -->
        <sidenav-router-link to="/marks/import" :exact="true">Import Marksheets</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-document" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')">
        <template slot="link-text">Markbook</template>
        <sidenav-router-link to="/markbook" :exact="true">Markbook</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-calendar" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')">
        <template slot="link-text">Attendance</template>
        <sidenav-router-link to="/attendance/daily" :exact="true">Daily Attendance</sidenav-router-link>
        <sidenav-router-link to="/attendance/daily/overview" :exact="true">Attendance Overview</sidenav-router-link>
        <sidenav-router-link to="/attendance/quarterly" :exact="true">Quarterly</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-chatbubbles" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')">
        <template slot="link-text">Comments</template>
        <sidenav-router-link to="/classcomments" :exact="true">Class Comments</sidenav-router-link>
        <sidenav-router-link to="/subjectcomments" :exact="true">Subject Comments</sidenav-router-link>
        <sidenav-router-link to="/nonacademiccomments" :exact="true">Non Academic Comments</sidenav-router-link>
        <sidenav-router-link to="/templatecomments" :exact="true">Template Comments</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-document" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')">
        <template slot="link-text">Reports</template>
        <sidenav-router-link to="/reports/class" :exact="true">Generate Class Report</sidenav-router-link>
        <sidenav-router-link to="/reports/grade" :exact="true">Generate Grade Report</sidenav-router-link>
        <sidenav-router-link to="/reports/settings" :exact="true">Report Dates</sidenav-router-link>
        <!-- <sidenav-router-link to="/transcripts" :exact="true">Generate Transcripts</sidenav-router-link> -->
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-stats" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')">
        <template slot="link-text">Analysis</template>
        <sidenav-router-link to="/analysis" :exact="true">Result Analysis</sidenav-router-link>
        <sidenav-router-link to="/graderanking" :exact="true">Grade Ranking</sidenav-router-link>
        <sidenav-router-link to="/classranking" :exact="true">Class Ranking</sidenav-router-link>
        <sidenav-router-link to="/pass-overview" :exact="true">Pass Overview</sidenav-router-link>
        <sidenav-router-link to="/finalschedule" :exact="true">Final Schedule</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-cash" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')" v-if="$can('manage', 'finance')">
        <template slot="link-text">Finances</template>
        <sidenav-router-link to="/finance/settings" :exact="true">Billables</sidenav-router-link>
        <sidenav-router-link to="/finance/learners" :exact="true">Learner Billables</sidenav-router-link>
        <!-- <sidenav-router-link to="/finance" :exact="true">Manage</sidenav-router-link> -->
        <sidenav-router-link to="/finance/capture" :exact="true">Capture Payments</sidenav-router-link>
        <sidenav-router-link to="/statement" :exact="true">Generate Statement</sidenav-router-link>
        <sidenav-router-link to="/emailstatement" :exact="true">Email Statement</sidenav-router-link>
        <sidenav-router-link to="/emailstatementhistory" :exact="true">Email Statement History</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-warning" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')">
        <template slot="link-text">Incidents</template>
        <sidenav-router-link to="/incidentsettings" :exact="true">Incident Settings</sidenav-router-link>
        <sidenav-router-link to="/incidents" :exact="true">Incidents</sidenav-router-link>
        <sidenav-router-link to="/incidents/reporting" :exact="true">Incidents Report</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-md-calendar" :active="isMenuActive('/dashboards')" :open="isMenuOpen('/dashboards')">
        <template slot="link-text">Meetings</template>
        <sidenav-router-link to="/meetingsettings" :exact="true">Meeting Settings</sidenav-router-link>
        <sidenav-router-link to="/meetings" :exact="true">Meetings</sidenav-router-link>
      </sidenav-menu>
    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  data () {
    return {}
  },

  created () {},

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
